import React, { useState, useEffect, useContext } from "react";
import "./Action.css";
import Colors from "../../Helper/Colors";
import { techappContext } from "../../Api/techappReq";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { Button, Modal, Input, Select, Alert } from "antd";
const { Option } = Select;
const { TextArea } = Input;

const RejectOrderModal = ({ rejectModal, setRejectModal, loading }) => {
  const { appInfo, appInfoData, sendAction } = useContext(techappContext);

  const [reasonOne, setReasonOne] = useState(null);
  const [reasonTwo, setReasonTwo] = useState(null);
  const [reasonTwoData, setReasonTwoData] = useState(null);
  const [desc, setDesc] = useState("");

  const order = useSelector((state) => state.TechAppReducer.orderObj);

  const onchangeOne = (value) => {
    setReasonTwo(null);
    setReasonOne(value);
    appInfoData.reasons_reject.forEach((reason) => {
      if (reason.title === value) {
        setReasonTwoData(reason.reasons);
      }
    });
  };

  useEffect(() => {
    appInfo();
  }, []);

  const submitReject = () => {
    let postData = {
      order_id: order.id,
      action: 7,
      desc: reasonTwo,
      added_desc: desc,
    };
    if (reasonOne === null) {
      toast.warning("لطفا موضوع را انتخاب کنید");
    } else if (reasonTwo === null) {
      toast.warning("لطفا دلیل رد کردن را انتخاب کنید");
    } else if (desc.length === 0) {
      toast.warning("لطفا توضیحات را وارد کنید");
    } else if (desc.length < 6) {
      toast.warning("توضیحات نباید کمتر از ۶ حرف باشد");
    } else {
      sendAction(7, postData);
    }
  };

  return (
    <>
      <Modal
        ariaHideApp={false}
        open={rejectModal}
        onOk={() => setRejectModal(false)}
        onCancel={() => setRejectModal(false)}
        className="techapp-action-cancel-order"
        style={{ borderRadius: "6px", textAlign: "center" }}
        title={"چرا میخواهید این کار را رَد کنید؟"}
        footer={[
          <>
            <Button
              onClick={() => setRejectModal(false)}
              className="tech-app-reset-data-btns btn-text-black"
              style={{
                backgroundColor: "rgba(199, 199, 199, 0.322)",
                color: "black",
              }}
              disabled={loading}
            >
              انصراف
            </Button>
            <Button
              onClick={submitReject}
              className="tech-app-reset-data-btns btn-text-white"
              style={{ backgroundColor: Colors.royalBlue, color: "white" }}
              loading={loading}
              id="decline_order_submit_button"
            >
              ثبت
            </Button>
          </>,
        ]}
      >
        <div className="tech-app-cancel-order-modal">
          <Select
            showSearch
            style={{ borderRadius: "6px" }}
            className="techapp-cancel-reason-select"
            placeholder={"انتخاب موضوع"}
            onChange={onchangeOne}
            value={reasonOne}
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            rootClassName="decline_order_title_select"
          >
            {appInfoData &&
              appInfoData.reasons_reject.map((reason, index) => (
                <Option
                  className="techapp-cancel-reason-options"
                  key={index}
                  value={reason.title}
                  id={`decline_order_title_option_${index}`}
                >
                  {reason.title}
                </Option>
              ))}
          </Select>
          {reasonOne && (
            <Select
              showSearch
              style={{ borderRadius: "6px" }}
              className="techapp-cancel-reason-select"
              placeholder={"انتخاب دلیل رد کردن"}
              value={reasonTwo}
              onChange={(value) => setReasonTwo(value)}
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              rootClassName="decline_order_reason_select"
            >
              {reasonTwoData &&
                reasonTwoData.map((reason, index) => (
                  <Option
                    className="techapp-cancel-reason-options"
                    key={index}
                    value={reason}
                    id={`decline_order_reason_option_${index}`}
                  >
                    {reason}
                  </Option>
                ))}
            </Select>
          )}
          <TextArea
            autoSize
            inputMode="text"
            value={desc}
            className="decline_order_description_input"
            onChange={(e) => setDesc(e.target.value)}
            placeholder={"توضیحات"}
            style={{
              maxHeight: "120px",
              paddingTop: "10px",
              textAlign: "center",
              margin: "10px 0",
            }}
          />
          {order?.assign_type === 3 ? (
            <Alert
              style={{ direction: "rtl", fontSize: 13 }}
              message="
این سفارش اختصاصی بوده و جز تعهدات شما به کاراباما است و باید آن را قبول کرده یا در صورت رد کردن باید با دلیل موجهی سفارش رد شود
اگر سفارش با تخصص یا منطقه درج شده در پروفایل شما همخوانی ندارد تیکت ثبت کرده و درخواست کنید منطقه یا تخصص شما تغییر داده شود.
در صورت رد کردن سفارش اختصاصی بدون دلیل موجه برای شما امتیاز منفی ثبت خواهد شد."
              type="warning"
            />
          ) : null}
        </div>
      </Modal>
    </>
  );
};
export default RejectOrderModal;
